import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { isError } from 'utils/ErrorMessages'
import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import {
  fetchDataError,
  fetchDataSuccess,
  updateDataError,
  updateDataSuccess,
  verifyDomainError,
  verifyDomainSuccess,
} from './actions'
import { DATA_REQUEST_ASYNC, DATA_UPDATE_REQUEST_ASYNC, VERIFY_DOMAIN_ASYNC } from './constants'

const fetchDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      DATA_REQUEST_ASYNC.INITIATE,
      DATA_UPDATE_REQUEST_ASYNC.SUCCESS,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.systemAlerts)
      return true
    }),
    mergeMap(() =>
      api.settings
        .getSystemNotificationsSettings(state$.value.partnerOptions.selectedCompany?.value)
        .pipe(
          map((response) => fetchDataSuccess(response)),
          catchError((error) =>
            of(
              // A thrown Error would be rethrown by epicsErrorHandler and kill every Settings
              // epic, leaving the loader on forever (IC-51198). Report it instead.
              isError(error)
                ? fetchDataError({ title: 'Error', detail: error.message, expectedErrorCodes: [] })
                : epicsErrorHandler(fetchDataError, error, [400])
            )
          ),
          takeUntil(action$.pipe(ofType(DATA_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

const updateDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DATA_UPDATE_REQUEST_ASYNC.INITIATE),
    mergeMap(() =>
      api.settings
        .updateSystemNotificationsSettings(
          state$.value.partnerOptions.selectedCompany?.value,
          state$.value.form.SystemNotifSettingsForm.values
        )
        .pipe(
          map((response) => updateDataSuccess(response)),
          catchError((error) => of(epicsErrorHandler(updateDataError, error, [400]))),
          takeUntil(action$.pipe(ofType(DATA_UPDATE_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

const verifyDomainEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(VERIFY_DOMAIN_ASYNC.INITIATE),
    mergeMap((action) =>
      api.settings
        .verifyDomain(
          action.payload.mailerDomain,
          state$.value.partnerOptions.selectedCompany?.value
        )
        .pipe(
          map((response) => verifyDomainSuccess(response)),
          catchError((error) => of(epicsErrorHandler(verifyDomainError, error, [400]))),
          takeUntil(action$.pipe(ofType(VERIFY_DOMAIN_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(fetchDataEpic, updateDataEpic, verifyDomainEpic)
